// Message contract for the CMS <-> test player preview handshake.
// Both sides must agree on these literals, see the handshake spec.
export const PLAYER_READY = 'PLAYER_READY'
export const SEND_PLAYER_TOKEN = 'SEND_PLAYER_TOKEN'

// How long the player waits for the CMS to hand over the preview token.
export const HANDSHAKE_TIMEOUT_MS = 5000

// PLAYER_READY is re-announced on this interval until the token arrives, so the
// player doesn't lose the handshake by signalling before the CMS attaches its
// message listener.
export const PLAYER_READY_RETRY_MS = 500

export const HANDSHAKE_ERRORS = {
    NO_OPENER: 'NO_OPENER',
    TIMEOUT: 'TIMEOUT',
    NOT_CONFIGURED: 'NOT_CONFIGURED',
}
